import React, { type ReactElement } from 'react';
import type { BaseCustomerUser } from 'services/assist-api/entities/customer-user/types';
import OrganisationUserOnlyMarkerBadge from './organisation-user-only-marker-badge';

export type SelectableMarkerBadgeProps = {
  organisationUser: BaseCustomerUser | undefined;
  warnIfNotCurrentUser: boolean;
};

export default function SelectableMarkerBadge({
  organisationUser,
  warnIfNotCurrentUser
}: SelectableMarkerBadgeProps): ReactElement {
  return (
    <OrganisationUserOnlyMarkerBadge
      organisationUser={organisationUser}
      warnIfNotCurrentUser={warnIfNotCurrentUser}
      omitTooltip // Omit tooltip since it can be considered intrusive when selecting.
    />
  );
}
